import { createFileRoute } from '@tanstack/react-router'

import { AdminChangeRequestsPage } from '@/systems/user-management/features/change-requests/components/AdminChangeRequestsPage'
import { adminChangeRequestsQueryOptions } from '@/systems/user-management/features/change-requests/hooks/useChangeRequests'

// Admin queue for user-submitted change requests (email or phone).
// Auth + role gating are inherited from the parent /user-management
// layout (admin / super_admin only). Default landing filter is `pending`
// so admin sees the work-to-do first.
export const Route = createFileRoute('/user-management/change-requests')({
  loader: ({ context: { queryClient } }) => {
    void queryClient.prefetchQuery(
      adminChangeRequestsQueryOptions({ status: 'pending', page: 1, page_size: 25 }),
    )
  },
  component: AdminChangeRequestsPage,
})
